var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-text-field',_vm._g(_vm._b({attrs:{"placeholder":_vm.placeholder,"label":_vm.with_label ? _vm.placeholder : undefined,"hide-details":"auto","autocomplete":_vm.$attrs.autocomplete || 'new-password'}},'w-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }